var cov_1lg6ycuv40 = function () {
  var path = "/Users/spana/SHEIN/shineout/src/Spin/index.tsx",
      hash = "cba44c213eef0cdaa916ef0b876f09a7ce191c9d",
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = "__coverage__",
      coverageData = {
    path: "/Users/spana/SHEIN/shineout/src/Spin/index.tsx",
    statementMap: {
      "0": {
        start: {
          line: 21,
          column: 14
        },
        end: {
          line: 35,
          column: 1
        }
      },
      "1": {
        start: {
          line: 38,
          column: 32
        },
        end: {
          line: 38,
          column: 37
        }
      },
      "2": {
        start: {
          line: 39,
          column: 2
        },
        end: {
          line: 44,
          column: 3
        }
      },
      "3": {
        start: {
          line: 48,
          column: 2
        },
        end: {
          line: 48,
          column: 37
        }
      },
      "4": {
        start: {
          line: 48,
          column: 26
        },
        end: {
          line: 48,
          column: 37
        }
      },
      "5": {
        start: {
          line: 49,
          column: 2
        },
        end: {
          line: 49,
          column: 51
        }
      },
      "6": {
        start: {
          line: 49,
          column: 33
        },
        end: {
          line: 49,
          column: 51
        }
      },
      "7": {
        start: {
          line: 50,
          column: 2
        },
        end: {
          line: 50,
          column: 18
        }
      },
      "8": {
        start: {
          line: 53,
          column: 38
        },
        end: {
          line: 84,
          column: 1
        }
      },
      "9": {
        start: {
          line: 54,
          column: 85
        },
        end: {
          line: 54,
          column: 90
        }
      },
      "10": {
        start: {
          line: 55,
          column: 15
        },
        end: {
          line: 55,
          column: 34
        }
      },
      "11": {
        start: {
          line: 56,
          column: 20
        },
        end: {
          line: 56,
          column: 53
        }
      },
      "12": {
        start: {
          line: 57,
          column: 2
        },
        end: {
          line: 60,
          column: 3
        }
      },
      "13": {
        start: {
          line: 58,
          column: 4
        },
        end: {
          line: 58,
          column: 52
        }
      },
      "14": {
        start: {
          line: 59,
          column: 4
        },
        end: {
          line: 59,
          column: 15
        }
      },
      "15": {
        start: {
          line: 61,
          column: 23
        },
        end: {
          line: 66,
          column: 3
        }
      },
      "16": {
        start: {
          line: 68,
          column: 2
        },
        end: {
          line: 81,
          column: 3
        }
      },
      "17": {
        start: {
          line: 69,
          column: 4
        },
        end: {
          line: 69,
          column: 116
        }
      },
      "18": {
        start: {
          line: 71,
          column: 4
        },
        end: {
          line: 80,
          column: 5
        }
      },
      "19": {
        start: {
          line: 82,
          column: 2
        },
        end: {
          line: 82,
          column: 54
        }
      },
      "20": {
        start: {
          line: 82,
          column: 16
        },
        end: {
          line: 82,
          column: 54
        }
      },
      "21": {
        start: {
          line: 83,
          column: 2
        },
        end: {
          line: 83,
          column: 16
        }
      },
      "22": {
        start: {
          line: 86,
          column: 0
        },
        end: {
          line: 86,
          column: 33
        }
      }
    },
    fnMap: {
      "0": {
        name: "renderContainer",
        decl: {
          start: {
            line: 37,
            column: 9
          },
          end: {
            line: 37,
            column: 24
          }
        },
        loc: {
          start: {
            line: 37,
            column: 100
          },
          end: {
            line: 45,
            column: 1
          }
        },
        line: 37
      },
      "1": {
        name: "getName",
        decl: {
          start: {
            line: 47,
            column: 9
          },
          end: {
            line: 47,
            column: 16
          }
        },
        loc: {
          start: {
            line: 47,
            column: 34
          },
          end: {
            line: 51,
            column: 1
          }
        },
        line: 47
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 53,
            column: 38
          },
          end: {
            line: 53,
            column: 39
          }
        },
        loc: {
          start: {
            line: 53,
            column: 64
          },
          end: {
            line: 84,
            column: 1
          }
        },
        line: 53
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 40,
            column: 43
          },
          end: {
            line: 40,
            column: 60
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 40,
            column: 43
          },
          end: {
            line: 40,
            column: 50
          }
        }, {
          start: {
            line: 40,
            column: 54
          },
          end: {
            line: 40,
            column: 60
          }
        }],
        line: 40
      },
      "1": {
        loc: {
          start: {
            line: 42,
            column: 7
          },
          end: {
            line: 42,
            column: 71
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 42,
            column: 7
          },
          end: {
            line: 42,
            column: 14
          }
        }, {
          start: {
            line: 42,
            column: 18
          },
          end: {
            line: 42,
            column: 71
          }
        }],
        line: 42
      },
      "2": {
        loc: {
          start: {
            line: 48,
            column: 2
          },
          end: {
            line: 48,
            column: 37
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 48,
            column: 2
          },
          end: {
            line: 48,
            column: 37
          }
        }, {
          start: {
            line: 48,
            column: 2
          },
          end: {
            line: 48,
            column: 37
          }
        }],
        line: 48
      },
      "3": {
        loc: {
          start: {
            line: 49,
            column: 2
          },
          end: {
            line: 49,
            column: 51
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 49,
            column: 2
          },
          end: {
            line: 49,
            column: 51
          }
        }, {
          start: {
            line: 49,
            column: 2
          },
          end: {
            line: 49,
            column: 51
          }
        }],
        line: 49
      },
      "4": {
        loc: {
          start: {
            line: 54,
            column: 38
          },
          end: {
            line: 54,
            column: 47
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 54,
            column: 45
          },
          end: {
            line: 54,
            column: 47
          }
        }],
        line: 54
      },
      "5": {
        loc: {
          start: {
            line: 54,
            column: 49
          },
          end: {
            line: 54,
            column: 66
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 54,
            column: 57
          },
          end: {
            line: 54,
            column: 66
          }
        }],
        line: 54
      },
      "6": {
        loc: {
          start: {
            line: 57,
            column: 2
          },
          end: {
            line: 60,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 57,
            column: 2
          },
          end: {
            line: 60,
            column: 3
          }
        }, {
          start: {
            line: 57,
            column: 2
          },
          end: {
            line: 60,
            column: 3
          }
        }],
        line: 57
      },
      "7": {
        loc: {
          start: {
            line: 68,
            column: 2
          },
          end: {
            line: 81,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 68,
            column: 2
          },
          end: {
            line: 81,
            column: 3
          }
        }, {
          start: {
            line: 68,
            column: 2
          },
          end: {
            line: 81,
            column: 3
          }
        }],
        line: 68
      },
      "8": {
        loc: {
          start: {
            line: 74,
            column: 9
          },
          end: {
            line: 78,
            column: 9
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 74,
            column: 9
          },
          end: {
            line: 74,
            column: 12
          }
        }, {
          start: {
            line: 75,
            column: 10
          },
          end: {
            line: 77,
            column: 16
          }
        }],
        line: 74
      },
      "9": {
        loc: {
          start: {
            line: 76,
            column: 13
          },
          end: {
            line: 76,
            column: 63
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 76,
            column: 39
          },
          end: {
            line: 76,
            column: 57
          }
        }, {
          start: {
            line: 76,
            column: 60
          },
          end: {
            line: 76,
            column: 63
          }
        }],
        line: 76
      },
      "10": {
        loc: {
          start: {
            line: 82,
            column: 2
          },
          end: {
            line: 82,
            column: 54
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 82,
            column: 2
          },
          end: {
            line: 82,
            column: 54
          }
        }, {
          start: {
            line: 82,
            column: 2
          },
          end: {
            line: 82,
            column: 54
          }
        }],
        line: 82
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0],
      "2": [0, 0],
      "3": [0, 0],
      "4": [0],
      "5": [0],
      "6": [0, 0],
      "7": [0, 0],
      "8": [0, 0],
      "9": [0, 0],
      "10": [0, 0]
    },
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184"
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

import _objectWithoutProperties from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";

var _jsxFileName = "/Users/spana/SHEIN/shineout/src/Spin/index.tsx",
    _this = this;

import React from 'react';
import classnames from 'classnames';
import config from '../config';
import configable from '../hoc/config';
import { spinClass } from './styles';
import { ChasingDots, DoubleBounce, ThreeBounce, ScaleCircle, FadingCircle, CubeGrid, ChasingRing, Wave, FourDots, Default } from './Multiple';
import { Ring, Plane, Pulse } from './Simple';
var spins = (cov_1lg6ycuv40.s[0]++, {
  plane: Plane,
  pulse: Pulse,
  ring: Ring,
  wave: Wave,
  "default": Default,
  'chasing-ring': ChasingRing,
  'chasing-dots': ChasingDots,
  'cube-grid': CubeGrid,
  'double-bounce': DoubleBounce,
  'fading-circle': FadingCircle,
  'four-dots': FourDots,
  'scale-circle': ScaleCircle,
  'three-bounce': ThreeBounce
});

function renderContainer(Loading, props) {
  cov_1lg6ycuv40.f[0]++;

  var _ref = (cov_1lg6ycuv40.s[1]++, props),
      loading = _ref.loading,
      children = _ref.children;

  cov_1lg6ycuv40.s[2]++;
  return (
    /*#__PURE__*/
    React.createElement("div", {
      className: spinClass('container', (cov_1lg6ycuv40.b[0][0]++, loading) && (cov_1lg6ycuv40.b[0][1]++, 'show')),
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 40,
        columnNumber: 5
      }
    },
    /*#__PURE__*/
    React.createElement("div", {
      className: spinClass('content'),
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 41,
        columnNumber: 7
      }
    }, children), (cov_1lg6ycuv40.b[1][0]++, loading) && (cov_1lg6ycuv40.b[1][1]++,
    /*#__PURE__*/
    React.createElement("div", {
      className: spinClass('loading'),
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 42,
        columnNumber: 19
      }
    }, Loading)))
  );
}

function getName(name) {
  cov_1lg6ycuv40.f[1]++;
  cov_1lg6ycuv40.s[3]++;

  if (name !== undefined) {
    cov_1lg6ycuv40.b[2][0]++;
    cov_1lg6ycuv40.s[4]++;
    return name;
  } else {
    cov_1lg6ycuv40.b[2][1]++;
  }

  cov_1lg6ycuv40.s[5]++;

  if (config.spin !== undefined) {
    cov_1lg6ycuv40.b[3][0]++;
    cov_1lg6ycuv40.s[6]++;
    return config.spin;
  } else {
    cov_1lg6ycuv40.b[3][1]++;
  }

  cov_1lg6ycuv40.s[7]++;
  return 'default';
}

cov_1lg6ycuv40.s[8]++;

var Spin = function Spin(props) {
  cov_1lg6ycuv40.f[2]++;

  var _ref2 = (cov_1lg6ycuv40.s[9]++, props),
      children = _ref2.children,
      style = _ref2.style,
      className = _ref2.className,
      _ref2$size = _ref2.size,
      size = _ref2$size === void 0 ? (cov_1lg6ycuv40.b[4][0]++, 40) : _ref2$size,
      _ref2$color = _ref2.color,
      color = _ref2$color === void 0 ? (cov_1lg6ycuv40.b[5][0]++, '#6c757d') : _ref2$color,
      tip = _ref2.tip,
      rest = _objectWithoutProperties(_ref2, ["children", "style", "className", "size", "color", "tip"]);

  var name = (cov_1lg6ycuv40.s[10]++, getName(props.name));
  var Component = (cov_1lg6ycuv40.s[11]++, spins[name]);
  cov_1lg6ycuv40.s[12]++;

  if (!Component) {
    cov_1lg6ycuv40.b[6][0]++;
    cov_1lg6ycuv40.s[13]++;
    console.warn("Spin type '".concat(name, "' not existed."));
    cov_1lg6ycuv40.s[14]++;
    return null;
  } else {
    cov_1lg6ycuv40.b[6][1]++;
  }

  var wrapperStyle = (cov_1lg6ycuv40.s[15]++, Object.assign({
    color: color
  }, style));
  var Content;
  cov_1lg6ycuv40.s[16]++;

  if (!('tip' in props)) {
    cov_1lg6ycuv40.b[7][0]++;
    cov_1lg6ycuv40.s[17]++;
    Content =
    /*#__PURE__*/
    React.createElement(Component, Object.assign({
      size: size,
      color: color
    }, rest, {
      wrapperStyle: wrapperStyle,
      wrapperClass: className,
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 69,
        columnNumber: 15
      }
    }));
  } else {
    cov_1lg6ycuv40.b[7][1]++;
    cov_1lg6ycuv40.s[18]++;
    Content =
    /*#__PURE__*/
    React.createElement("div", {
      style: wrapperStyle,
      className: classnames(spinClass('_'), className),
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 72,
        columnNumber: 7
      }
    },
    /*#__PURE__*/
    React.createElement(Component, Object.assign({
      size: size,
      color: color
    }, rest, {
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 73,
        columnNumber: 9
      }
    })), (cov_1lg6ycuv40.b[8][0]++, tip) && (cov_1lg6ycuv40.b[8][1]++,
    /*#__PURE__*/
    React.createElement("div", {
      className: spinClass('tip'),
      style: {
        color: color
      },
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 75,
        columnNumber: 11
      }
    }, typeof tip === 'string' ? (cov_1lg6ycuv40.b[9][0]++,
    /*#__PURE__*/
    React.createElement("span", {
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 76,
        columnNumber: 40
      }
    }, tip)) : (cov_1lg6ycuv40.b[9][1]++, tip))));
  }

  cov_1lg6ycuv40.s[19]++;

  if (children) {
    cov_1lg6ycuv40.b[10][0]++;
    cov_1lg6ycuv40.s[20]++;
    return renderContainer(Content, props);
  } else {
    cov_1lg6ycuv40.b[10][1]++;
  }

  cov_1lg6ycuv40.s[21]++;
  return Content;
};

cov_1lg6ycuv40.s[22]++;
Spin.displayName = 'ShineoutSpin';
export default configable(Spin, 'spin');